import { render, staticRenderFns } from "./LoggingOverview.vue?vue&type=template&id=3b3bddae&scoped=true"
import script from "./LoggingOverview.vue?vue&type=script&lang=js"
export * from "./LoggingOverview.vue?vue&type=script&lang=js"
import style0 from "./LoggingOverview.vue?vue&type=style&index=0&id=3b3bddae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bddae",
  null
  
)

export default component.exports